import React, { useEffect, useState } from 'react';

import { Card, Button } from 'react-bootstrap';
import { useAuth } from '../../../Auth';
import { useAxios } from '../../../AxiosHandler';
import { useTranslate } from 'react-polyglot';
import 'react-toastify/dist/ReactToastify.css';
import './Persons.scss';
import PageTable from '../../Shared/PageTable/PageTable';
import FilterSelector from '../../Shared/FilterSelector/FilterSelector';
import CreatePersonModal from '../../Shared/Modals/Create/CreatePersonModal';
import EditPersonModal from '../../Shared/Modals/Edit/EditPersonModal';
import DeletePersonModal from '../../Shared/Modals/Delete/DeletePersonModal';
import SMSSender from '../../Shared/SMSSender/SMSSender';
import EmailSender from '../../Shared/EmailSender/EmailSender';

function Persons() {
    const auth = useAuth();
    const t = useTranslate();
    const axiosHandler = useAxios();
    const axios = axiosHandler.axios;

    const [updateTable, setUpdateTable] = useState(0);
    const [personsFilter, setPersonsFilter] = useState([]);

    const [selectedItems, setSelectedItems] = useState<any>([]);
    const [showSMSSendModal, setShowSMSSendModal,] = useState(false);
    const [showEmailSendModal, setShowEmailSendModal,] = useState(false);

    const [showCreatePersonModal, setShowCreatePersonModal] = useState(false);
    const [showDeletePersonModal, setShowDeletePersonModal] = useState(false); //Modal no longer in use, can likely be removed
    const [showEditPersonModal, setShowEditPersonModal] = useState(false);
    const [editPersonId, setEditPersonId] = useState("");
    const [editPersonOrg, setEditPersonOrg] = useState("");
    const [deletePersonId, setDeletePersonId] = useState();

    const handleShowSMSSendModal = () => { setShowSMSSendModal(true); };
    const handleShowEmailSendModal = () => { setShowEmailSendModal(true); };
    const handleShowCreateModal = () => { setShowCreatePersonModal(true); };
    // const handleShowDeleteModal = (dataLine, evt) => {
    //     evt.stopPropagation();
    //     evt.nativeEvent.stopImmediatePropagation();
    //     setDeletePersonId(dataLine["_id"]);
    //     setShowDeletePersonModal(true);
    // };

    const handleShowEditModal = (dataLine) => {
        setEditPersonId(dataLine["_id"]);
        setEditPersonOrg(dataLine["organization"]);
        setShowEditPersonModal(true);
    };

    const handleSendSMS = (selectedIds) => {
        setSelectedItems(selectedIds);
        handleShowSMSSendModal();
    }

    const handleSendEmail = (selectedIds) => {
        setSelectedItems(selectedIds);
        handleShowEmailSendModal();
    }

    function fetchExcelPeopleReport() {
        axios.single({
            method: "post",
            url: "/api/reports/fullpeopleexcel/",
            responseType: "arraybuffer",
            headers: {'x-access-token': auth.user["token"]}
        }).then(res => {
            let file = Buffer.from(res.data);
            const blob = new Blob( [ file ], { type: 'text/plain' } );
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.style.display = 'none';
            a.href = url;
            // the filename you want
            a.download = "Peoplerapport_" + new Date().toISOString().split(".")[0] + ".xlsx";
            document.body.appendChild(a);
            a.click();
            window.URL.revokeObjectURL(url);
        });
    }

    useEffect(() => {
        if (auth.user["userdata"] == undefined) { window.location.href = "/login"; }
    }, []);

    return (
        <div className="maincontent">
            <div className="persons-container">
                <Card>
                    <Card.Body>
                        <h4 className="header-title">{t("people.title")}</h4>
                        <div className="no-print">
                            {auth.user["userdata"]["role"][0] === "Admin" &&
                                <Button className="newpersonBtn" onClick={handleShowCreateModal}>{t("people.new")}</Button>
                            }
                            {auth.user["userdata"]["role"][0] === "Admin" &&
                                <Button onClick={fetchExcelPeopleReport} style={{float: "right"}}>{t("people.excel_report")}</Button>
                            }
                            <br />
                            <hr />
                            <p>{t("people.filters")}</p>
                            <FilterSelector
                                filtersUrl="/api/filters/bytype/"
                                filterType="person"
                                fields={[
                                    { label: t("people.lastname"), value: "lastname", type: "string" },
                                    { label: t("people.firstname"), value: "firstname", type: "string" },
                                    { label: t("people.email"), value: "email", type: "string" },
                                    { label: t("people.phone"), value: "phone", type: "string" },
                                    { label: t("people.organization"), value: "organization", type: "string" },
                                    { label: t("people.resources"), value: "currentResources", type: "string" },
                                ]}
                                onChange={(filter) => {
                                    setPersonsFilter(filter.filters);
                                }}
                                onAddClick={ auth.user["userdata"]["role"][0] === "Admin" ? () => {} : undefined}
                                onEditClick={ auth.user["userdata"]["role"][0] === "Admin" ? () => {} : undefined}
                                onDeleteClick={ auth.user["userdata"]["role"][0] === "Admin" ? () => {} : undefined}
                                addFilterText={t("general.addfilter")}
                            ></FilterSelector>
                        </div>
                        
                        <PageTable
                            dataUrl="/api/persons/getAllPaged/"
                            checkAllUrl="/api/persons/getAllPaged/checkAll"
                            allDataUrl="/api/persons"
                            selectedFunctions={[
                                { label: t("people.list.multifunctions.send_sms"), func: (selectedItems) => handleSendSMS(selectedItems) },
                                { label: t("people.list.multifunctions.send_email"), func: (selectedItems) => handleSendEmail(selectedItems) },
                            ]}
                            options={{
                                showFields: [
                                    { label: t("people.lastname"), field: "lastname" },
                                    { label: t("people.firstname"), field: "firstname" },
                                    { label: t("people.email"), field: "email" },
                                    { label: t("people.phone"), field: "phone" },
                                    { label: t("people.organization"), field: "organization" },
                                    { label: t("people.resources"), field: "currentResources" },
                                ]
                            }}
                            // dataAfter={(dataLine) =>
                            //     auth.user["userdata"]["role"] == "Admin" ?
                            //         <Button className="no-print" onClick={(evt) => handleShowDeleteModal(dataLine, evt)}> {t("people.delete")} </Button>
                            //         : null
                            // }
                            onLineClick={handleShowEditModal}
                            hidePagination={false}
                            hidePagesize={false}
                            hideFilter={false}
                            updateTable={updateTable}
                            hover={true}
                            permaFilters={personsFilter}
                        />
                    </Card.Body>
                </Card>
                <CreatePersonModal
                    show={showCreatePersonModal}
                    onCancel={() => setShowCreatePersonModal(false)}
                    onHide={() => setShowCreatePersonModal(false)}
                    onSaveNew={() => { setShowCreatePersonModal(false); setUpdateTable(updateTable + 1); }}
                ></CreatePersonModal>
                <EditPersonModal
                    show={showEditPersonModal}
                    personId={editPersonId}
                    org={editPersonOrg}
                    onCancel={() => setShowEditPersonModal(false)}
                    onHide={() => setShowEditPersonModal(false)}
                    onSaveEdit={() => {
                        setShowEditPersonModal(false);
                        setUpdateTable(updateTable + 1);
                    }}
                ></EditPersonModal>
                <DeletePersonModal
                    show={showDeletePersonModal}
                    personId={deletePersonId}
                    onCancel={() => setShowDeletePersonModal(false)}
                    onHide={() => setShowDeletePersonModal(false)}
                    onDeleted={() => {
                        setShowDeletePersonModal(false);
                        setUpdateTable(updateTable + 1);
                    }}
                ></DeletePersonModal>
                <SMSSender
                    show={showSMSSendModal}
                    onHide={() => setShowSMSSendModal(false)}
                    onCancel={() => setShowSMSSendModal(false)}
                    recipients={selectedItems.map(i => { return { number: i.phone, name: i.lastname + ", " + i.firstname } })}
                ></SMSSender>
                <EmailSender
                    show={showEmailSendModal}
                    onHide={() => setShowEmailSendModal(false)}
                    onCancel={() => setShowEmailSendModal(false)}
                    recipients={selectedItems.map(i => { return { email: i.email, name: i.lastname + ", " + i.firstname } })}
                ></EmailSender>
            </div>
        </div>
    );
}

export default Persons;